import instRequest from 'utils/instRequest'
import ErrorMessage from 'utils/ErrorMessage'
import studentRequest from 'utils/studentRequest'
import { message } from 'antd'

export const approveApprovalRequest = requestId => async () => {
  try {
    const response = await studentRequest.put(
      `/approval-requests/${requestId}/approve`,{}
    )

    return response?.data?.data || null
  } catch (err) {
    ErrorMessage('Error approving request. Try again.')
    return null
  }
}

export const bulkApproveApprovalRequests = payload => async () => {
  try {
    const response = await studentRequest.put(
      '/approval-requests/bulk-approve',
      payload
    )

    return response?.data?.data || null
  } catch (err) {
    ErrorMessage('Error approving all requests. Try again.')
    return null
  }
}

export const rejectApprovalRequest = (requestId, payload) => async () => {
  try {
    const response = await studentRequest.put(
      `/approval-requests/${requestId}/reject`,
      payload
    )

    return response?.data?.data || null
  } catch (err) {
    ErrorMessage('Error rejecting request. Try again.')
    return null
  }
}

export const getApprovalRequests = studentId => async () => {
  try {
    const response = await studentRequest.get(
      `/students/${studentId}/approval-requests?status=PENDING`
    )

    console.log('Approval API response:', response)

    return response?.data?.data || {}
  } catch (err) {
    console.error('Approval API error:', err)
    ErrorMessage('Error fetching approval requests. Try again.')
    return {}
  }
}

export const getProfileApprovalListing = (instituteCampusId, search, sortField, sortOrder, page = 1, limit = 10, yearOfPassing = null, courses = []) => async () => {
  try {
    const url = `/institutes/${instituteCampusId}/profile-approval-listing`
    const payload = {
      page,
      limit,
    }
    
    if (search) {
      payload.search = search
    }
    if (sortField && sortOrder) {
      payload.sortBy = sortField
      payload.sortOrder = sortOrder
    }
    if (yearOfPassing) {
      payload.yearOfPassing = yearOfPassing
    }
    if (courses && courses.length > 0) {
      payload.courses = courses
    }
    
    const response = await studentRequest.post(url, payload)
console.log("response",response)  
    return response?.data?.data || null
  } catch (err) {
    ErrorMessage('Error fetching profile approval listing. Try again.')
    return null
  }
}

export const getYearOfPassingFilter = instituteCampusId => async () => {
  try {
    const response = await studentRequest.get(
      `/institutes/${instituteCampusId}/profile-approval-listing/year-of-passing`
    )
    return response?.data?.data || null
  } catch (err) {
    ErrorMessage('Error fetching year of passing data. Try again.')
    return null
  }
}
export const getStudentDataById = studentId => async () => {
  try {
    const response = await studentRequest.get(`/students/${studentId}`)
    return response?.data?.data || null
  } catch (err) {
    ErrorMessage('Error fetching student data. Try again.')
    return null
  }
}

export const getDegreeHierarchyFilter = instituteCampusId => async () => {
  try {
    const response = await studentRequest.get(
      `/institutes/${instituteCampusId}/profile-approval-listing/degree-hierarchy`
    )
    return response?.data?.data || null
  } catch (err) {
    ErrorMessage('Error fetching degree hierarchy data. Try again.')
    return null
  }
}
export const getPendingDataByStudentId = studentId => async () => {
  try {
    const response = await studentRequest.get(
      `/students/${studentId}/approval-requests?status=PENDING`
    )
    return response?.data?.data || null
  } catch (err) {
    ErrorMessage('Error fetching pending data. Try again.')
    return null
  }
}

export const getTPOApprovalConfig = () => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = state?.auth?.instituteDetails?.id 

  if (!instituteCampusId) {
    return null
  }

  try {
    const response = await instRequest.get(
      `/institutes/${instituteCampusId}/tpo-approval-config`
    )

    if (response?.data?.data) {
      return response.data.data
    }
    return null
  } catch (error) {
    console.error('Error fetching TPO approval config:', error)
    return null
  }
}

export const toggleTPOApproval = (isEnabled) => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = state?.auth?.instituteDetails?.id

  if (!instituteCampusId) {
    ErrorMessage('Institute campus ID not found')
    return { success: false, error: 'No institute campus ID' }
  }

  try {
    const payload = {
      isRequestForTPOApproval: isEnabled
    }

    const response = await instRequest.put(
      `/institutes/${instituteCampusId}/toggle-tpo-approval`,
      payload
    )

    if (response?.data) {
      message.success(`Profile approval ${isEnabled ? 'enabled' : 'disabled'} successfully`)
      return { success: true, data: response.data }
    }
  } catch (error) {
    console.error('Error toggling TPO approval:', error)
    ErrorMessage(
      error?.response?.data?.message || 'Failed to update approval setting. Please try again.'
    )
    return { success: false, error: error?.response?.data?.message }
  }
}

export const updateTPOApprovalConfig = (payload) => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = state?.auth?.instituteDetails?.id

  if (!instituteCampusId) {
    ErrorMessage('Institute campus ID not found')
    return { success: false, error: 'No institute campus ID' }
  }

  try {
    const response = await instRequest.put(
      `/institutes/${instituteCampusId}/tpo-approval-config`,
      payload
    )

    if (response?.data) {
      message.success('Settings saved successfully')
      return { success: true, data: response.data }
    }
  } catch (error) {
    console.error('Error saving TPO approval settings:', error)
    ErrorMessage(
      error?.response?.data?.message || 'Failed to save settings. Please try again.'
    )
    return { success: false, error: error?.response?.data?.message }
  }
}

export const updateStudentData = (payload) => async () => {
  try {
    const response = await studentRequest.put(
      `/students/${payload.student.id}`,
      payload
    )

    if (response?.data) {
      message.success('Student data updated successfully')
      return { success: true, data: response.data }
    }
  } catch (error) {
    console.error('Error updating student data:', error)
    ErrorMessage(
      error?.response?.data?.message || 'Failed to update student data. Please try again.'
    )
    return { success: false, error: error?.response?.data?.message }
  }
}

export const buildTPOApprovalPayload = (values) => {
  const fieldMapping = {
    'personal.CV / Resume Upload': 'cv',
    'personal.First Name': 'firstName',
    'personal.Last Name': 'lastName',
    'personal.Date of Birth': 'dob',
    'personal.Gender': 'gender',
    'personal.Primary Email Address': 'primaryEmail',
    'personal.Mobile Number': 'phoneNumber',
    'permanent.Country': 'permCountry',
    'permanent.State': 'permState',
    'permanent.City': 'permCity',
    'permanent.Pincode': 'permPostCode',
    'Current.Country': 'corrCountry',
    'Current.State': 'corrState',
    'Current.City': 'corrCity',
    'Current.Pincode': 'corrPostCode',
    '10thDetails.Board': 'tenth.board',
    '10thDetails.Year (end)': 'tenth.endYear',
    '10thDetails.Marks (In %) - If it is cgpa convert it to %': 'tenth.marks',
    '10thDetails.Uploaded MarkSheet': 'tenth.markSheetUrl',
    '12thDetails.Board': 'twelfth.board',
    '12thDetails.Year (end)': 'twelfth.endYear',
    '12thDetails.Marks (In %) - If it is cgpa convert it to %': 'twelfth.marks',
    '12thDetails.Uploaded MarkSheet': 'twelfth.markSheetUrl',
    'EducationalDetails.State': 'otherEducation.state',
    'EducationalDetails.City': 'otherEducation.city',
    'EducationalDetails.College Name': 'otherEducation.collegeName',
    'EducationalDetails.University': 'otherEducation.university',
    'EducationalDetails.Degree': 'otherEducation.degree',
    'EducationalDetails.Department': 'otherEducation.department',
    'EducationalDetails.Specialization': 'otherEducation.specialisation',
    'EducationalDetails.End Year': 'otherEducation.endYear',
    'EducationalDetails.Marks (In %) - If it is cgpa convert it to %': 'otherEducation.marks',
    'EducationalDetails.Uploaded MarkSheet': 'otherEducation.markSheetUrl',
    'Pursuing.State': 'currentCourse.state',
    'Pursuing.City': 'currentCourse.city',
    'Pursuing.College Name': 'currentCourse.collegeName',
    'Pursuing.University': 'currentCourse.university',
    'Pursuing.Degree': 'currentCourse.degree',
    'Pursuing.Department': 'currentCourse.department',
    'Pursuing.Specialization': 'currentCourse.specialisation',
    'Pursuing.Year of Passing': 'currentCourse.endYear',
    'Pursuing.Marks (In %) - If it is cgpa convert it to %': 'currentCourse.marks',
    'Pursuing.Arrears - Current Arrears/History of Arrears': 'currentCourse.noOfArrears',
    'Pursuing.Uploaded MarkSheet': 'currentCourse.markSheetUrl',
    'Projects.Project Title': 'projects.title',
    'Projects.Start Month': 'projects.started_in',
    // 'Projects.Start Year': 'projects.startYear',
    'Projects.End Month': 'projects.ended_in',
    // 'Projects.End Year': 'projects.endYear',
    'Projects.Description about the project': 'projects.description',
    'Projects.Skills': 'projects.certifications',
    'Projects.Uploaded Certifications': 'projects.certifications',
    'Projects.Adding New Project': 'projects.addNew',
    'Internships.Company Name': 'internships.companyName',
    'Internships.Start Month': 'internships.started_in',
    // 'Internships.Start Year': 'internships.startYear',
    'Internships.End Month': 'internships.ended_in',
    // 'Internships.End Year': 'internships.endYear',
    'Internships.Function': 'internships.function',
    'Internships.Role': 'internships.role',
    'Internships.Industry': 'internships.industry',
    'Internships.Description (Roles & Responsibilities)': 'internships.description',
    'Internships.Skills': 'internships.certifications',
    'Internships.Uploaded Certifications': 'internships.certifications',
    'Internships.Adding New Internship': 'internships.addNew',
    'WorkExperience.Company Name': 'workExperience.companyName',
    'WorkExperience.Start Month': 'workExperience.started_in',
    // 'WorkExperience.Start Year': 'workExperience.startYear',
    'WorkExperience.End Month': 'workExperience.ended_in',
    // 'WorkExperience.End Year': 'workExperience.endYear',
    'WorkExperience.Function': 'workExperience.function',
    'WorkExperience.Role': 'workExperience.role',
    'WorkExperience.Industry': 'workExperience.industry',
    'WorkExperience.Description (Roles & Responsibilities)': 'workExperience.description',
    'WorkExperience.Skills': 'workExperience.certifications',
    'WorkExperience.Uploaded Certifications': 'workExperience.certifications',
    'WorkExperience.Adding New Work Experience': 'workExperience.addNew',
    'Certifications.Institute Name': 'certifications.organisation',
    'Certifications.Course Name': 'certifications.title',
    'Certifications.Start Month': 'certifications.started_in',
    // 'Certifications.Start Year': 'certifications.issueYear',
    'Certifications.End Month': 'certifications.ended_in',
    // 'Certifications.End Year': 'certifications.expiryYear',
    'Certifications.Description about the Certification': 'certifications.description',
    'Certifications.Skills': 'certifications.credentialUrl',
    'Certifications.Uploaded Certification': 'certifications.certificate',
    'Certifications.Adding New Certification': 'certifications.addNew',
    'ExtraCurricular.Adding New Extracurricular Activities': 'extraCurriculars',
  }

  const fields = {}

  Object.keys(fieldMapping).forEach(uiKey => {
    const apiKey = fieldMapping[uiKey]
    const editableKey = `${uiKey}.editable`
    const lockedKey = `${uiKey}.locked`

    fields[apiKey] = {
      requiresApproval: !!values[editableKey],
      freezeAfterVerification: !!values[lockedKey],
    }
  })

  return {
    tpoApprovalConfig: {
      fields,
    },
  }
}

export const getStudentResumeData = (studentId) => async () => {
  try {
    const response = await studentRequest.get(
      `/students/${studentId}/resumes`
    )
    return response?.data?.data || {}
  } catch (error) {
    console.log('Error in getting student resume data', error)
    return {}
  }
}

export const upsertStudentResume = (studentId, data) => async () => {
  try {
    const response = await studentRequest.post(
      `/students/${studentId}/resumes/batch`,
      data
    )
    return response?.data?.data || {}
  } catch (error) {
    console.log('Error in upserting student resume', error)
    throw error
  }
}
